import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { ButtonIconComponent } from '../button-icon/button-icon.component';

@Component({
    selector: 'btn-actions',
    templateUrl: './button-actions.component.html',
    styleUrls: ['./button-actions.component.scss'],
    imports: [ButtonIconComponent],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ButtonActionsComponent {
    id = input<string>('');
    disabled = input<boolean>(false);

    onClick = output<MouseEvent>();
}
